function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Amplify, { Auth } from 'aws-amplify';
import { awsConfig } from './auth-config';

var AuthStore = function AuthStore() {
  var _this = this;

  _classCallCheck(this, AuthStore);

  this.subscribe = function (subscriber) {
    _this.subscriber = subscriber;
  };

  this.unsubscribe = function () {
    _this.subscriber = null;
  };

  this.notify = function (authenticated) {
    if (_this.subscriber) _this.subscriber(authenticated);
  };

  this.isAuthenticated = function () {
    return Boolean(Auth.userPool.getCurrentUser());
  };

  this.getCredentials =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var credentials;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Auth.currentCredentials();

          case 3:
            credentials = _context.sent;

            _this.notify(credentials.authenticated);

            return _context.abrupt("return", credentials);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            _this.notify(false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 8]]);
  }));
  Amplify.configure(awsConfig);
};

export default AuthStore;